<div mat-dialog-title>
  <span>{{ 'VERSIONING.VERSIONS_HISTORY' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<mat-dialog-content class="version-content">
  <ng-container *ngIf="!isLoading(); else loader">
    <div class="no-history" *ngIf="!(versionsHistory$ | async)?.length">
      <img [src]="noItemsImage" alt="no_items" />
      <div class="no-history__text">{{ 'VERSIONING.VERSIONS_HISTORY_EMPTY' | translate }}</div>
    </div>

    <div *ngIf="(versionsHistory$ | async)?.length" class="some-history">
      <div class="versions-container">
        <div
          *ngFor="let versionHistoryItem of versionsHistory$ | async"
          class="versions-container__version-state"
          [ngClass]="{
            'versions-container__version-state_chosen':
              chosenVersionHistoryItem === versionHistoryItem
          }"
          (click)="changeChosenVersionHistoryItem(versionHistoryItem)">
          {{ versionHistoryItem | versionName }}
        </div>
      </div>

      <div class="timeline-box">
        <app-version-history-tree
          [versionHistoryItem]="chosenVersionHistoryItem"></app-version-history-tree>
      </div>
    </div>
  </ng-container>

  <ng-template #loader>
    <q9-content-loader [isLoading]="true" class="no-history"></q9-content-loader>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions>
  <q9-icon-button
    icon="information-icon"
    [matTooltip]="'ASIDE_R.VERSIONS_INFORMATION' | translate"
    (click)="goToArticle()"></q9-icon-button>
</mat-dialog-actions>
